module.exports = __webpack_public_path__ + "2c55db944f7984babc1d7afe80d540e8.svg";